import {
    getCascadesByProject,
    updateCascadeChannelPriority,
} from '@/api/networkFixer'
import { PROVIDER_TYPES } from '@/vars/general'

/**
 * Assigns last priority to a newly created channel in mailings / notifications / crmMessages.
 * Mirrors AddChannelSidebarContent.assignLastPriorityToChannel.
 */
export async function assignLastCascadePriority(options: {
    projectId: string
    channelId: number | string
    providerType: string
    notify?: (message: string) => void
}): Promise<void> {
    const { projectId, channelId, providerType, notify } = options

    if (channelId === null || channelId === undefined || channelId === '') {
        console.warn('Не удалось присвоить приоритет: отсутствует channelId')
        return
    }

    // Same checks as sidebar / ChannelsTable: legacy `whatsapp` and Multichat `dh-whatsapp`.
    const isWhatsappDh =
        providerType === PROVIDER_TYPES.whatsapp ||
        providerType === PROVIDER_TYPES.whatsappDh

    try {
        const { data: cascades, error } = await getCascadesByProject(projectId)
        if (error) {
            console.error('Ошибка загрузки каскадов:', error)
            return
        }

        if (!cascades || cascades.length === 0) {
            notify?.('На проекте нет каскадов. Приоритет для нового канала не установлен.')
            return
        }

        const availableCascadeTypes = new Set(
            (cascades || []).map((c: any) => c?.cascadeType).filter(Boolean)
        )
        const cascadeTypes = ['mailings', 'notifications', 'crmMessages'].filter((type) =>
            availableCascadeTypes.has(type)
        )

        for (const cascadeType of cascadeTypes) {
            if (cascadeType === 'notifications' && isWhatsappDh) {
                continue
            }

            const cascade = cascades?.find((c: any) => c && c.cascadeType === cascadeType)
            if (!cascade) {
                continue
            }

            const existingChannels = cascade.channels || []
            const maxPriority =
                existingChannels.length > 0
                    ? Math.max(...existingChannels.map((ch: any) => ch.priority || 0))
                    : 0
            const newPriority = maxPriority + 1

            const { error: updateError } = await updateCascadeChannelPriority({
                cascadeId: cascade.id,
                channelId: Number(channelId),
                priority: newPriority,
            })

            if (updateError) {
                console.error(`Ошибка установки приоритета для ${cascadeType}:`, updateError)
            }
        }
    } catch (error) {
        console.error('Ошибка при присвоении приоритетов каналу:', String(error))
    }
}
